import React, { useEffect, useState, useRef } from 'react'
import { primaryColor } from '../../assets/jss/material-dashboard-react'
import { reloadData, GPS, BoundaryStyling, Company, defaultCenter, Site, RedirectProps, APISiteLoggerDetail} from '../../components/Site Functions/LoadSiteDetailsData'
import moment from 'moment'
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import { Coordinates } from '../../components/Site Functions/LoadSiteData';
import Loader from '../../Utils/Loader/NewLoader2025'
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter, Selection } from 'devextreme-react/data-grid';
import { Button, Checkbox, Chip, useTheme } from '@mui/material';
import { isLCLLogger } from 'variables/chariotProductIds';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import GoogleMapComponent from '../../components/Map/NewGoogleMaps2024';
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import ImagesPanel from 'components/ImageUpload/ImagesPanel'
import UploadDialog from "../../components/ImageUpload/UploadDialog"
import Comments from '../../components/Comments/Comments';
import { transform } from '@babel/core';
import { Redirect } from "react-router-dom";
import SiteModalMobile from './SiteModalMobile';
interface Props {
    classes: {
        root: string;
        heading: string;
        cardTitleWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            siteId: number;
            siteName: string;
        };
        search: string;
    };
}

const SiteDetailsMobile: React.FC<Props> = ({ history, location, classes }) => {


    //hooks
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    const intl: IntlShape = useIntl()


    ///container style
    const containerStyle = {
        height: "500px",
        width: isTablet ? isLandscape ? "109%" : "110%" : isLandscape ? "117%" : "148%",
        transform: isTablet ? isLandscape ? "translateX(-4%)" : "translateX(-3%)" : isLandscape ? "translateX(-7%)" : "translateX(-16%)"
    };


    const mapRef = useRef(null);
    const [site, setSite] = useState<Site>()
    const [loading, setLoading] = useState<boolean>(false)
    const [tableHidden, setTableHidden] = useState<boolean>(false)
    const [loggerData, setLoggerData] = useState<Array<APISiteLoggerDetail>>([])
    const [historicLoggerData, setHistoricLoggerData] = useState<Array<APILoggerDetail>>([])
    const [mapKey, setMapKey] = useState<string>("")
    const [center, setCenter] = useState<Coordinates>(defaultCenter)
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [hasBoundary, setHasBoundary] = useState<boolean>(false)
    const [polygonPath, setPolygonPath] = useState([]);
    const [boundaryStyling, setBoundaryStyle] = useState<BoundaryStyling>(
        {
            strokeWeight: 2,
            strokeColor: '#FF0000',
            areaColor: '#FF0000',
            transparency: 35
        })
    const [hoveredMarker, setHoveredMarker] = useState(null)
    const [chariotModal, setChariotModal] = useState(false)
    const [torModal, setTorModal] = useState(false)
    const [tempDevice, setTempDevice] = useState<Array<APILoggerDetail>>([])
    const [authorized, setAuthorized] = useState<boolean>(true)
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({
        siteName: "",
        siteId: null,
        serial: "",
        deviceId: null
    })
    const [loggerIds, setLoggerIds] = useState([])
    const [modal, setModal] = useState(false)
    const [loggersToBeAssigned, setLoggersToBeAssigned] = useState([])
    const [loggersToBeUnassigned, setLoggersToBeUnassigned] = useState([])
    const [companies, setCompanies] = useState<Array<Company>>([])
    const [lastDataDate, setLastDataDate] = useState<Date | null>()
    const [uploadDialogOpen, setUploadDialogOpen] = useState<boolean>(false)

    const [loggersToGraph, setLoggersToGraph] = useState<Array<APILoggerDetail>>([])
    ///dates

    const [startDate, setStartDate] = useState<Date>(moment(lastDataDate).subtract(8, 'days').toDate())
    const [endDate, setEndDate] = useState<Date>(moment(lastDataDate).toDate())
    const [showLinkDate, setShowLinkDate] = useState<boolean>(false)
    const [openDropDowns, setOpenDropDowns] = useState<Array<string>>([])
    const [linkDates, setLinkDates] = useState<boolean>(false)
    const [selectedItemIndex, setSelectedItemIndex] = useState<number>()
    const [showMap, setShowMap] = useState<boolean>(false)


    useEffect(() => {
        reloadData(
            setLoading,
            location.state.siteId,
            setPolygonPath,
            setSite,
            setLoggerData,
            setBoundaryStyle,
            setHasBoundary,
            setMarkers,
            setLoggersToBeAssigned,
            setAuthorized,
            startDate,
            setLastDataDate,
            setHistoricLoggerData,
            setLoggerIds)
    }, [])

    const renderSerialTemplate = ({ data }): React.ReactNode => {
        const theme = useTheme()
        return <Chip
            style={{ marginTop: "3px" }}
            label={data.serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={(): void => onMarkerClick(data.serial)}
        />
    }

    const onMarkerClick = (serial: number): void => {

        const clickedMarker = loggerData.filter(logger => logger.serial === serial)

        setRedirect(true)
        setRedirectPath(!isLCLLogger(clickedMarker[0].model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({
            serial: serial,
            mapKey: 'test'
        })
    }

    const renderOutputCheckBox = ({ data }): React.ReactNode => {

        return <Checkbox checked={data.isSiteOutput} color="primary" onClick={(): void => handleCheckBoxClick(data)} />
    }

    const handleCheckBoxClick = (data) => {
        setLoading(true)
        const yes = confirm('Are you sure you want to change this Device?')
        if (yes) {
            CallPutAPI(CreateUrl(`/api/Aquaguard/SetOutputDevice?serial=${data.serial}&value=${!data.isSiteOutput}`), {})
                .then(data => {
                    setTimeout(() => reloadData(
                        setLoading,
                        location.state.siteId,
                        setPolygonPath,
                        setSite,
                        setLoggerData,
                        setBoundaryStyle,
                        setHasBoundary,
                        setMarkers,
                        setLoggersToBeAssigned,
                        setAuthorized,
                        startDate,
                        setLastDataDate,
                        setHistoricLoggerData,
                        setLoggerIds), 500)
                    createSuccessNotification()

                })
                .catch(err => {
                    createErrorNotification()
                    console.error(err)
                    setLoading(false)
                })
        } else return
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert('callback');
        });
    };


    const renderDateTime = (data ): React.ReactNode => {
        if (data?.column.name === 'startDate') {
            return <div>{moment(data.data.startDate).format('DD MMM YYYY')}</div>
        } 
        if (data?.column.name === 'endDate') {
            return <div>{moment(data.data.endDate).format('DD MMM YYYY')}</div>
        } 
        
    }



    const onMapLoad = (map) => {
        mapRef.current = map;
        map.setMapTypeId("hybrid")
        fitBoundsToMarkers(); // Fit bounds after the map loads

        if (!hasBoundary && markers.length === 1) {
            setTimeout(() => {
                mapRef.current.setZoom(18)
            }, 500)
        }
    };

    const onPolygonClick = () => {
        /* do nothing */
    }

    const updatePolygonPath = () => {
        /*do nothing in this component */
    }

    const handleTooltipShow = (serial: number): void => {

        setHoveredMarker(serial)
    }

    const handleTooltipHide = (): void => {
        setHoveredMarker(null)
    }


    const fitBoundsToMarkers = () => {

        if (mapRef.current && markers.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.forEach((marker) => {
                bounds.extend(marker.position);
            });
            if (hasBoundary) {
                polygonPath.forEach((corner) => {
                    bounds.extend(corner)
                })
            }
            mapRef.current.fitBounds(bounds);
        } else if (mapRef.current && polygonPath.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            polygonPath.forEach((corner) => {
                bounds.extend(corner)
            })
            mapRef.current.fitBounds(bounds);
        }
    };



    const handleDropDownOpen = (e: AccordionTypes.SelectionChangedEvent): void => {
        let openDropDownsTemp: Array<number>
        if (e.addedItems.length > 0) {

            openDropDownsTemp = [...openDropDowns, e.addedItems[0].title]

        }
        if (e.removedItems.length > 0) {
            openDropDownsTemp = openDropDowns.filter(d => d !== e.removedItems[0].title)
        }

        if (openDropDownsTemp.includes('Graph') && openDropDownsTemp.includes('Minimum Night Flow')) {

            setShowLinkDate(true)
        } else {
            setShowLinkDate(false)
        }
        setOpenDropDowns(openDropDownsTemp)
    }

    const handleUploadButtonClick = (): void => {
        setUploadDialogOpen(!uploadDialogOpen)
    }

  


    return (
        <>
            {!redirect &&
                <div>
                    {loading &&
                        <div style={{
                            position: 'absolute', left: 'Calc(50% - 100px)', top: 'Calc(50% - 100px)',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 13000
                        }}>
                            <Loader color={undefined} />
                        </div>
                    }
                    {!loading &&
                        <>
                        
                            <div style={{ width: "119%", height: "54px", background: primaryColor[0], transform: isTablet ? isLandscape ? "translateX(-2%)" : "translateX(-1%)" : isLandscape ? 'translateX(-4%)' : 'translateX(-8%)', marginTop: "-35px" }}>
                                <h4 style={{ color: "white", padding: "10px 0 0 20px" }}><FormattedMessage id='Site'/>: {site?.siteName}</h4>
                        </div>
                        {console.log(intl.locale) }
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                <div style={{ width: "100%", display: intl.locale !== 'en-GB' ? "block" : "flex"}}>
                                <div style={{ width: intl.locale !== 'en-GB'? "100%": "50%", marginRight: "8px" }}>
                                    <FullWidthMobileButton disabled={false} color="error" onClick={(): void => history.goBack()} text={intl.formatMessage({ id: "Back" })} />
                                    </div>
                                <div style={{ width: showMap ? "50%" : "100%", marginTop: intl.locale !== 'en-GB' ? 10 : 0 }}>
                                        <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: showMap ? "Hide map" : "Show on Map" }) } onClick={(): void => setShowMap(!showMap)} color="secondary" />
                                    </div>
                                </div>
                               
                        </div>
                        {/*<div style={{display: "flex", justifyContent: "center", marginTop: "10px"} }>
                                
                            //</div>*/}
                        {showMap && <div style={{ margin: 40 }}>
                            {(markers.length > 0 || polygonPath.length > 0) && <GoogleMapComponent
                                mapKey={mapKey}
                                containerStyle={containerStyle}
                                center={center}
                                onMapLoad={onMapLoad}
                                markers={markers}
                                hasBoundary={hasBoundary}
                                createBoundary={false}
                                polygonPath={polygonPath}
                                boundaryStyling={boundaryStyling}
                                onPolygonClick={onPolygonClick}
                                updatePolygonPath={updatePolygonPath}
                                handleMouseOverMarker={handleTooltipShow}
                                handleMouseOutMarker={handleTooltipHide}
                                onMarkerClick={onMarkerClick}
                                hoveredMarker={hoveredMarker}
                                editBoundary={false}
                                showTooltip={true}
                            />}
                        </div>}
                            <div>
                                <h4 style={{ textAlign: "center", marginTop: 20, color: "black" }}>
                                    <b><FormattedMessage id='Active Devices at Site'/></b>
                                </h4>

                                <DataGrid
                                    dataSource={loggerData}
                                >
                                <StateStoring enabled={true} type="localStorage" storageKey="UserListGrid" />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={true} />
                                    <HeaderFilter visible={true} />
                                    <Column dataField="serial" cellRender={(data): React.ReactNode => renderSerialTemplate(data)} caption={intl.formatMessage({id: 'Serial'})} />
                                    <Column dataField="deviceName" caption={intl.formatMessage({ id: 'Device Name' })} />
                                <Column dataField="isSiteOutput" dataType="boolean" caption={intl.formatMessage({ id: "Site Output" })} width={120} cellRender={renderOutputCheckBox} />
                                </DataGrid>
                            </div>
                            <div>
                                <h4 style={{ textAlign: "center", marginTop: 20, color: "black" }}>
                                <b><FormattedMessage id='Historic Devices at Site'/></b>
                                </h4>
                                <DataGrid
                                dataSource={historicLoggerData}
                                style={{marginBottom: 20} }
                                >
                                    <StateStoring enabled={true} type="localStorage" storageKey="UserListGrid" />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={true} />
                                    <HeaderFilter visible={true} />
                                    <Column dataField="serial" cellRender={(data): React.ReactNode => renderSerialTemplate(data)} caption={intl.formatMessage({ id: "Serial" })} />
                                    <Column dataField="startDate" cellRender={(data): React.ReactNode => renderDateTime(data)} caption={intl.formatMessage({ id: "Start Date" })} />
                                    <Column dataField="endDate" cellRender={(data): React.ReactNode => renderDateTime(data)} caption={intl.formatMessage({ id: "End Date" })} />
                                </DataGrid>
                                
                                <div style={{ width: isTablet ? "105%" : isLandscape ? "107%" : "119%", transform: isTablet ? isLandscape ? "translateX(-2.5%)" : "translateX(-3%)" : isLandscape ? 'translateX(-3%)' : 'translateX(-8%)' }}>
                                    <Accordion
                                        collapsible={true}
                                        multiple={true}
                                        onSelectionChanged={(e) => handleDropDownOpen(e)}
                                        defaultSelectedIndex={-1}
                                    >
                                        <Item title={intl.formatMessage({ id: "Comments" })} >
                                            <Comments lcLoggerId={null} loggerId={null} siteId={location.state.siteId} />
                                        </Item>
                                        <Item title={intl.formatMessage({ id: "Images" })} >
                                            <div>
                                                <ImagesPanel siteId={location.state.siteId} />
                                                <Button
                                                    variant="contained"
                                                    onClick={(): void => handleUploadButtonClick()}
                                                >
                                                    <FormattedMessage id="Upload" />
                                                </Button>
                                            </div>
                                        </Item>
                                    </Accordion>
                                </div>
                            </div>
                        </>}
                </div>
            }
            {redirect && <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} /> }
        </>
    )
}
export default SiteDetailsMobile